/**
 * Helpers pour éviter les re-renders inutiles sur les listes en auto-refresh.
 *
 * `listsEqualById(prev, next)` renvoie true si les 2 listes contiennent
 * exactement les mêmes éléments (même id, même updated_at) dans le même ordre.
 * Sinon false.
 *
 * Usage dans un fetch :
 *   setXxx(prev => listsEqualById(prev, res.data) ? prev : res.data);
 *
 * Effet : si rien n'a changé côté serveur, React ne rerend rien → plus de
 * "saut" visuel pendant l'auto-refresh silencieux.
 */

export function listsEqualById(prev, next) {
    if (prev === next) return true;
    if (!Array.isArray(prev) || !Array.isArray(next)) return false;
    if (prev.length !== next.length) return false;
    for (let i = 0; i < prev.length; i++) {
        const a = prev[i];
        const b = next[i];
        if (!a || !b) return false;
        if (a.id !== b.id) return false;
        // updated_at couvre la majorité des changements; si absent, on compare
        // quelques champs frequents pour rester précis.
        if ((a.updated_at || null) !== (b.updated_at || null)) return false;
    }
    return true;
}
